import { render } from "./AdditionalInfoStepFamilyChildComponent.vue?vue&type=template&id=5fafc7ac&ts=true"
import script from "./AdditionalInfoStepFamilyChildComponent?vue&type=script&lang=ts"
export * from "./AdditionalInfoStepFamilyChildComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__